import type { LayoutDataType } from '../../types';

export const OBEDIENCE_OPTIONS: {
  id: NonNullable<LayoutDataType['obedience']>;
  title: string;
}[] = [
  {
    id: 'agree',
    title: 'Agree',
  },
  {
    id: 'challenge',
    title: 'Challenge',
  },
];
